import { render, staticRenderFns } from "./GastosTab.vue?vue&type=template&id=f2bff2b0&scoped=true"
import script from "./GastosTab.vue?vue&type=script&lang=js"
export * from "./GastosTab.vue?vue&type=script&lang=js"
import style0 from "./GastosTab.vue?vue&type=style&index=0&id=f2bff2b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2bff2b0",
  null
  
)

export default component.exports